import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../api';

interface DismissResponse {
  status: string;
}

/**
 * Hook to dismiss the get started panel with automatic cache invalidation.
 * When the panel is dismissed, the checkLogin query (which fetches from /info)
 * will be invalidated to refetch and update the show_get_started_panel flag.
 */
export const useDismissGetStartedPanel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<DismissResponse> => {
      const response = await client.post<DismissResponse>('/get-started-panel/dismiss');
      return response.data;
    },
    onSuccess: () => {
      // Invalidate the checkLogin query to refetch user data and update feature flags
      queryClient.invalidateQueries({ queryKey: ['checkLogin'] });
    },
  });
};
